import { z } from 'zod';

const changelogHighlightSchema = z.object({
  icon: z.string().min(1),
  title: z.string().min(1),
  description: z.string().min(1),
});

export const updateChangelogEntrySchema = z
  .object({
    version: z
      .string()
      .regex(/^\d+\.\d+\.\d+$/, 'Version must be in semver format (e.g. 1.0.0)')
      .optional(),
    release_date: z.string().min(1).optional(),
    title_fr: z.string().min(1).optional(),
    title_en: z.string().min(1).optional(),
    highlights_fr: z.array(changelogHighlightSchema).optional(),
    highlights_en: z.array(changelogHighlightSchema).optional(),
    improvements_fr: z.array(z.string()).optional(),
    improvements_en: z.array(z.string()).optional(),
    fixes_fr: z.array(z.string()).optional(),
    fixes_en: z.array(z.string()).optional(),
    is_published: z.boolean().optional(),
  })
  .refine((obj) => Object.keys(obj).length > 0, {
    message: 'At least one field is required',
  });

export type UpdateChangelogEntryPayload = z.infer<typeof updateChangelogEntrySchema>;
